// Scenario configurations for sector impacts
export const SCENARIO_CONFIGS = {
  current: {
    low: {
      food: 'current',
      buildings: 'current',
      transport: 'current',
      industry: 'current'
    },
    high: {
      food: 'current',
      buildings: 'current',
      transport: 'current',
      industry: 'current'
    }
  },
  steer: {
    low: {
      food: 'current',
      buildings: 'current',
      transport: 'low',
      industry: 'low'
    },
    high: {
      food: 'current',
      buildings: 'low',
      transport: 'low',
      industry: 'low'
    }
  },
  shift: {
    low: {
      food: 'low',
      buildings: 'low',
      transport: 'high',
      industry: 'low'
    },
    high: {
      food: 'low',
      buildings: 'high',
      transport: 'low',
      industry: 'low'
    }
  },
  transform: {
    low: {
      food: 'low',
      buildings: 'high',
      transport: 'high',
      industry: 'low'
    },
    high: {
      food: 'high',
      buildings: 'high',
      transport: 'high',
      industry: 'high'
    }
  },
  net_zero_futures_dvl_shift_high_transstshiftec_2001: {
    panel: {
      food: 'panel',
      buildings: 'panel',
      transport: 'panel',
      industry: 'panel'
    }
  }
};

export const SCENARIO_LOOKUP = {
  current: {
    low: {
        copy:'Darren test'
    },
    high: {
        copy:'Darren test'
    }
  },
  steer: {
    low: {
      copy:'Less Change + Steer'
    },
    high: {

        copy:'More Change + Steer'
    }
  },
  shift: {
    low: {
        copy:'Less Change + Shift'

    },
    high: {
    copy:'More Change + Shift '
    }
  },
  transform: {
    low: {
    copy:'Less Change + Transform'
    },
    high: {
    copy:'More Change + Transform'
    }
  },
  net_zero_futures_dvl_shift_high_transstshiftec_2001: {
    panel: {
      copy: "Final citizens' panel scenario"
    }
  }
};

// Helper function to get scenario configuration
export const getScenarioConfig = (scenarioKey, variant = 'low') => {
  // Handle the special scenario case
  if (scenarioKey === 'net_zero_futures_dvl_shift_high_transstshiftec_2001') {
    return SCENARIO_CONFIGS[scenarioKey]?.panel || SCENARIO_CONFIGS[scenarioKey];
  }
  
  // Validate inputs
  const validScenarios = ['current', 'steer', 'shift', 'transform'];
  const validVariants = ['low', 'high'];

  // Ensure valid scenario and variant
  if (!validScenarios.includes(scenarioKey)) {
    // console.warn(`Invalid scenario: ${scenarioKey}. Defaulting to 'current'.`);
    scenarioKey = 'current';
  }

  if (!validVariants.includes(variant)) {
    // console.warn(`Invalid variant: ${variant}. Defaulting to 'low'.`);
    variant = 'low';
  }

  // Return the specific configuration
  return SCENARIO_CONFIGS[scenarioKey][variant];
};

export const getScenarioLookup = (scenarioKey, variant = 'low') => {
  // Handle the special scenario case
  if (scenarioKey === 'net_zero_futures_dvl_shift_high_transstshiftec_2001') {
    return SCENARIO_LOOKUP[scenarioKey]?.panel ?? { copy: "Final citizens' panel scenario" };
  }
  
  const validScenarios = ['current','steer','shift','transform'];
  const validVariants  = ['low','high'];
  const s = validScenarios.includes(scenarioKey) ? scenarioKey : 'current';
  const v = validVariants.includes(variant) ? variant : 'low';
  return SCENARIO_LOOKUP[s]?.[v] ?? { copy: '' };
};
